import "./App.scss";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Homepage from "./pages/Homepage/Homepage";
import ServicesPage from "./pages/ServicesPage/ServicesPage";
import ProjectsPage from "./pages/ProjectsPage/ProjectsPage";
import NotFound from "./pages/NotFound/NotFound";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import ProjectGrace from "./pages/ProjectGrace/ProjectGrace";
import ProjectFFWBCW from "./pages/ProjectFFWBCW/ProjectFFWBCW";
import ScrollFix from "./components/ScrollFix/ScrollFix";
import { Toaster } from "react-hot-toast";
import ProjectHereBoy from "./pages/ProjectHereBoy/ProjectHereBoy";

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollFix />

        <Navbar />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/project/ffwbcw" element={<ProjectFFWBCW />} />
          <Route path="/project/hereboy" element={<ProjectHereBoy />} />
          <Route path="/project/moreofgrace" element={<ProjectGrace />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </Router>

      <Toaster />
    </div>
  );
}

export default App;
